import { getItemByLabelFactory, getItemByIdFactory } from './_common'
import type { ISelectItem } from '~/types/models'

export enum ContactTypeIds {
  // id 1 is reserved for 'unassigned',
  // which theoretically should never happen
  COMPANY = 2,
  SUPPLIER = 3,
  TSD = 4,
  LEAD_SOURCE = 5,
}

export function getContactTypes(): ISelectItem[] {
  return [
    { id: ContactTypeIds.COMPANY, label: 'Company' },
    { id: ContactTypeIds.SUPPLIER, label: 'Supplier' },
    { id: ContactTypeIds.TSD, label: 'TSD' },
    { id: ContactTypeIds.LEAD_SOURCE, label: 'Lead Source' },
  ]
}

export const getContactTypeByLabel = getItemByLabelFactory(getContactTypes)
export const getContactTypeById = getItemByIdFactory(getContactTypes)
